module.exports = __webpack_public_path__ + "static/media/enterprise-graphic.3ec9128f.png";